const FORMATS = ['ean_13', 'ean_8', 'upc_a', 'upc_e', 'code_128', 'qr_code']

async function detectNative(source) {
  if (typeof window === 'undefined' || typeof window.BarcodeDetector !== 'function') return null
  try {
    const detector = new window.BarcodeDetector({ formats: FORMATS })
    const codes = await detector.detect(source)
    const first = codes?.[0]
    if (!first?.rawValue) return null
    return { value: String(first.rawValue), format: first.format || '', engine: 'native' }
  } catch {
    return null
  }
}

async function detectWithZxing(blob) {
  try {
    const { BrowserMultiFormatReader } = await import('@zxing/browser')
    const reader = new BrowserMultiFormatReader()
    const url = URL.createObjectURL(blob)
    try {
      const result = await reader.decodeFromImageUrl(url)
      const value = result?.getText?.() || result?.text
      if (!value) return null
      return {
        value: String(value),
        format: String(result?.getBarcodeFormat?.() || ''),
        engine: 'zxing',
      }
    } finally {
      URL.revokeObjectURL(url)
      reader.reset?.()
    }
  } catch {
    return null
  }
}

export async function readBarcodeFromBlob(blob) {
  if (!blob) return null
  const nativeFromBlob = await detectNative(blob)
  if (nativeFromBlob) return nativeFromBlob
  try {
    const bitmap = await createImageBitmap(blob)
    const nativeFromBitmap = await detectNative(bitmap)
    if (typeof bitmap.close === 'function') bitmap.close()
    if (nativeFromBitmap) return nativeFromBitmap
  } catch {
    // Safari iOS ne fournit pas toujours createImageBitmap/BarcodeDetector.
  }
  return detectWithZxing(blob)
}
